// User
export const LOGIN_LOADING_TRUE = 'LOGIN_LOADING_TRUE';
export const LOGIN_LOADING_FALSE = 'LOGIN_LOADING_FALSE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
